import { render, staticRenderFns } from "./MicrosoftRedirectView.vue?vue&type=template&id=3d9ce629"
import script from "./MicrosoftRedirectView.vue?vue&type=script&lang=js"
export * from "./MicrosoftRedirectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports